<template>
  <div class="vehicle-list">
    <el-card>
      <div slot="header" style="display: flex; justify-content: space-between; align-items: center;">
        <span>在场车辆列表</span>
        <el-button type="primary" size="small" @click="dialogVisible = true">车辆入场</el-button>
      </div>

      <el-table :data="tableData" border stripe>
        <el-table-column prop="plateNumber" label="车牌号" width="120"></el-table-column>
        <el-table-column prop="ownerName" label="车主姓名" width="120"></el-table-column>
        <el-table-column prop="ownerPhone" label="联系电话" width="140"></el-table-column>
        <el-table-column prop="parkingLotName" label="停车场" min-width="150"></el-table-column>
        <el-table-column prop="entryTime" label="入场时间" width="180">
          <template slot-scope="scope">
            {{ formatTime(scope.row.entryTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button type="warning" size="small" @click="handleExit(scope.row.id)">出场</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog title="车辆入场" :visible.sync="dialogVisible" width="500px">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="车牌号" prop="plateNumber">
          <el-input v-model="form.plateNumber" placeholder="请输入车牌号"></el-input>
        </el-form-item>
        <el-form-item label="车主姓名" prop="ownerName">
          <el-input v-model="form.ownerName" placeholder="请输入车主姓名"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="ownerPhone">
          <el-input v-model="form.ownerPhone" placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <el-form-item label="停车场" prop="parkingLotId">
          <el-select v-model="form.parkingLotId" placeholder="请选择停车场" style="width: 100%">
            <el-option v-for="item in parkingLots" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { vehicleApi, parkingApi } from '@/api'

export default {
  data() {
    return {
      tableData: [],
      parkingLots: [],
      dialogVisible: false,
      form: {
        plateNumber: '',
        ownerName: '',
        ownerPhone: '',
        parkingLotId: ''
      },
      rules: {
        plateNumber: [{ required: true, message: '请输入车牌号', trigger: 'blur' }],
        ownerName: [{ required: true, message: '请输入车主姓名', trigger: 'blur' }],
        ownerPhone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        parkingLotId: [{ required: true, message: '请选择停车场', trigger: 'change' }]
      }
    }
  },
  mounted() {
    this.loadData()
    this.loadParkingLots()
  },
  methods: {
    async loadData() {
      try {
        const { data } = await vehicleApi.getList({ status: 'parked' })
        this.tableData = data
      } catch (error) {
        this.$message.error('加载失败')
      }
    },
    async loadParkingLots() {
      try {
        const { data } = await parkingApi.getList()
        this.parkingLots = data
      } catch (error) {
        this.$message.error('加载停车场失败')
      }
    },
    formatTime(time) {
      return new Date(time).toLocaleString('zh-CN')
    },
    async handleExit(id) {
      try {
        await this.$confirm('确定车辆出场?', '提示', { type: 'warning' })
        await vehicleApi.exit(id)
        this.$message.success('出场成功')
        this.loadData()
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('出场失败')
        }
      }
    },
    handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            await vehicleApi.entry(this.form)
            this.$message.success('入场成功')
            this.dialogVisible = false
            this.form = { plateNumber: '', ownerName: '', ownerPhone: '', parkingLotId: '' }
            this.loadData()
          } catch (error) {
            this.$message.error('入场失败')
          }
        }
      })
    }
  }
}
</script>
